import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/backend-logs`;

export const listBackendLogs = (params) =>
  axios.get(`${API_PREFIX}`, {
    params,
    headers: getAuthHeaders(),
  });

export const getBackendLogsFilterOptions = () =>
  axios.get(`${API_PREFIX}/filter-options`, {
    headers: getAuthHeaders(),
  });

export const getBackendLogDetail = (id) =>
  axios.get(`${API_PREFIX}/${encodeURIComponent(id)}`, {
    headers: getAuthHeaders(),
  });
